export default __webpack_public_path__ + "static/media/product_karier.0bc84ec6.png";